import { FC } from 'react';
import { Button } from '@carbon/react';
import style from './no-match-card.module.scss';

interface Props {
  onSelectEntityMatch?: () => void;
}

export const NoMatchCard: FC<Props> = ({ onSelectEntityMatch }) => (
  <div className={style.card}>
    <div className={style.title}>No match found</div>
    <p className={style.body}>
      No existing individual or organization entity matched this party. Use
      Select Entity Match to search for an entity or create a new
      individual/organization entity.
    </p>
    {onSelectEntityMatch && (
      <div className={style.actions}>
        <Button kind="primary" size="sm" onClick={onSelectEntityMatch}>
          Select Entity Match
        </Button>
      </div>
    )}
  </div>
);
